module.exports = __webpack_public_path__ + "static/airqualitybt/images/layers.svg";